
/*window.addEventListener('scroll', fixNav);
function fixNav() {
  const Header = document.querySelector('.header');
  if (window.scrollY > Header.offsetHeight - 110) {
    Header.classList.add('header--active')
  } else {
    Header.classList.remove('header--active')
  }
}*/
// Accessibilité du burger 
document.body.classList.toggle('js-enabled');

// SI L'ALERTE EST PRÉSENTE AJOUT D'UNE CLASS AU BODY.

if (document.querySelector('.AlertBanner') != null) {
  jQuery('body').addClass('alert-activated');
  let alertHeight = jQuery('.AlertBanner').innerHeight(); // valeur de la hauteur de l'alerte
  jQuery('.header').css({ top: alertHeight + 'px' }); // mettre la hauteur de l'alerte comme valeur à la position top du header
}
jQuery('.dismiss_icon').click(function () {
  jQuery('body').removeClass('alert-activated');
  jQuery('.header').css({ top: '0px' });
});

jQuery(document).ready(function($) {
  // Fonction de toggle pour les filtres
  $('.SidebarSearch__filters-item-header').click(function() {
    var parentItem = $(this).closest('.SidebarSearch__filters-item');
    
    // Toggle de la classe 'active'
    parentItem.toggleClass('SidebarSearch__filters-item--active');
    
    // SlideToggle pour ouvrir/fermer le contenu
    parentItem.find('.SidebarSearch__filters-item-content').slideToggle();
  });
});

const mobileFilter = document.getElementById('MobileFilter');
if (mobileFilter) {
  mobileFilter.addEventListener('click', function() {
    document.body.classList.toggle('MobileFilter--activated');
  });
}